<template>
    <div>
        <div class="row">
            <div class="col-10 col-sm-11 col-md-11 col-lg-11 col-xl-11">
                <app-input v-model="addOnName"
                           id="addon-name"
                           label="Add-on Name"
                           type="text"
                           placeholder="e.g. T-Shirt or Material Fee"
                           :name="addOnInputName"
                           v-validate="'required|max:255'">
                </app-input>
            </div>
            <div class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 pb-3 d-flex align-items-center cursor-pointer"
                 @click="$emit('remove')">
                <img src="../../../../assets/img/delete-red.svg">
            </div>
        </div>
        <div class="row">
            <div class="col-10 col-sm-4 col-md-5 col-lg-5 col-xl-6">
                <div class="form-group position-relative">
                    <label>Cost</label>
                    <money label="Cost"
                           type="text"
                           placeholder="$0.00"
                           maxlength="15"
                           :key="addOn.id"
                           :name="addOnInputPriceName"
                           v-validate="{required, 'bigger-or-equal': 0}"
                           v-model="addOnPrice"
                           v-bind="money">
                    </money>
                    <div class="error">{{ errors.first(addOnInputPriceName) }}</div>
                </div>
            </div>
            <div class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
            <div class="col-7 col-sm-4 col-md-3 col-lg-3 col-xl-3">
                <number-peel label="Max"
                             :name="addOnMaxName"
                             v-model="addOnMaxAmount"
                             class="mr-4">
                </number-peel>
            </div>
            <div class="col-5 col-sm-3 col-md-3 col-lg-3 col-xl-2">
                <div class="mt-4 p-2 flex-column">
                    <checkbox v-bind:checked.sync="addOnRequired">
                        Required
                    </checkbox>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Money} from 'v-money';
    import {PriceMaskMixin} from '@/mixins/PriceMaskMixin';

    export default {
        name: 'AddOn',
        components: {
            Checkbox:     () => import(/* webpackChunkName: 'camp-form' */ '../../../controls/Checkbox'),
            NumberPeel:   () => import(/* webpackChunkName: 'camp-form' */ '../../../controls/NumberPeel'),
            AppInput:     () => import(/* webpackChunkName: 'camp-form' */ '../../../controls/AppInput'),
            Money
        },
        inject: ['$validator'],
        mixins: [PriceMaskMixin],
        props: {
            addOn: {
                type: Object,
                required: true
            },
            required: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                addOnInputName: 'add-on-name-' + Math.random() * 10,
                addOnInputPriceName: 'add-on-price-' + Math.random() * 10,
                addOnMaxName: 'add-on-max' + Math.random() * 10
            }
        },
        computed: {
            addOnName: {
                get() {
                    return this.addOn.name;
                },
                set(value) {
                    this.$emit('input:name', value);
                }
            },
            addOnPrice: {
                get() {
                    return this.addOn.price;
                },
                set(value) {
                    this.$emit('input:price', value);
                }
            },
            addOnRequired: {
                get() {
                    return this.addOn.required;
                },
                set(value) {
                    this.$emit('input:required', value);
                }
            },
            addOnMaxAmount: {
                get() {
                    return this.addOn.maxAmount;
                },
                set(value) {
                    this.$emit('input:max-amount', value);
                }
            }
        }
    }
</script>

<style>
    .remove-addon {
        margin-top: 28px;
        cursor: pointer;
        width: max-content;
        width: 35px;
        height: 35px;
        box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.2);
    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/camp-form/AddOn.vue